import axios from 'axios';
import { Comic } from '../types/Comic';

const API_BASE_URL = process.env.REACT_APP_API_ENDPOINT || '';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const getComics = async (token: string): Promise<Comic[]> => {
  try {
    const response = await api.get('/comics', {
      headers: {
        Authorization: token,
      },
    });
    return response.data.comics || [];
  } catch (error: any) {
    console.error('Error fetching comics:', error);
    throw new Error(error.response?.data?.error || 'Failed to fetch comics');
  }
};

export const getComic = async (token: string, email: string): Promise<Comic> => {
  try {
    const response = await api.get(`/comics/${encodeURIComponent(email)}`, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  } catch (error: any) {
    console.error('Error fetching comic:', error);
    throw new Error(error.response?.data?.error || 'Failed to fetch comic');
  }
};

export const createComic = async (token: string, comic: Omit<Comic, never>): Promise<Comic> => {
  try {
    const response = await api.post('/comics', comic, {
      headers: {
        Authorization: token,
      },
    });
    return response.data.comic;
  } catch (error: any) {
    console.error('Error creating comic:', error);
    throw new Error(error.response?.data?.error || 'Failed to create comic');
  }
};

export const updateComic = async (
  token: string,
  email: string,
  updates: Partial<Comic>
): Promise<Comic> => {
  try {
    const response = await api.put(`/comics/${encodeURIComponent(email)}`, updates, {
      headers: {
        Authorization: token,
      },
    });
    return response.data.comic;
  } catch (error: any) {
    console.error('Error updating comic:', error);
    throw new Error(error.response?.data?.error || 'Failed to update comic');
  }
};

export const deleteComic = async (token: string, email: string): Promise<void> => {
  try {
    await api.delete(`/comics/${encodeURIComponent(email)}`, {
      headers: {
        Authorization: token,
      },
    });
  } catch (error: any) {
    console.error('Error deleting comic:', error);
    throw new Error(error.response?.data?.error || 'Failed to delete comic');
  }
};
